import { DeliveryTimeType } from '@/features/orders/constants/app'
import { DeliveryTime } from '@/features/orders/types/app'
import i18n from '@/translations'
import dayjs from 'dayjs'

export const formatDeliveryTime = (time: DeliveryTime): string => {
    const format = 'HH:mm'

    const formattedEnd = dayjs(time.end).format(format)
    const formattedStart = dayjs(time.start).format(format)

    switch (time.type) {
        case DeliveryTimeType.Asap:
            return i18n.t('order.deliveryTime.asap', { time: formattedEnd })
        case DeliveryTimeType.Exact:
            return formattedEnd
        case DeliveryTimeType.Window:
            return formattedStart + ' - ' + formattedEnd
        default:
            return i18n.t('order.deliveryTime.unknown')
    }
}
